import { Maybe } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'

export interface DeliveryAddress {
  line1: Maybe<string>
  line2: Maybe<string>
  city: Maybe<string>
  stateProvince: Maybe<string>
  postalCode: Maybe<string>
  locationName: Maybe<string>
}
export function formatAddress(deliveryAddress: DeliveryAddress): string {
  const { line1, line2, city, stateProvince, postalCode, locationName } = deliveryAddress

  const arr: string[] = [locationName, line1, line2, city, stateProvince, postalCode]
    .filter((e) => Boolean(e))
    .map((e) => String(e))

  return arr.reduce((acc, curr) => `${acc} ${curr}`, '').trim()
}
